import React, { useContext } from 'react'
import Information from '../global/Information'
import LinkStyleButton from '../global/buttons/LinkStyleButton'
import { IconLibrary } from  '@/interfaces/IconLibrary'
import Icon from '../icons/Icons'
import { ContentAudienceContext } from './ContentAudienceContext'

const ItemInMultiplePlacesNotification = () => {
    const {addToExistsMessageSeen, showParentModal} = useContext(ContentAudienceContext)

    return <Information
        text={<>
            <span>This item appears in multiple lists, so its total audience may include different groups from each parent list.</span>
            <LinkStyleButton content={'View Parents'} ariaLabel={'View all parent lists'} onButtonClick={showParentModal} />
            </>
        } 
        className='exists-in-mulitple-locations-alert'
        icon={<Icon iconName={IconLibrary.LINKED} sizeInPx={'12'} color='#6A7C96'/>}
        onClose={() => addToExistsMessageSeen()}
    />
}

export default ItemInMultiplePlacesNotification